import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { createSelector } from 'reselect';

import { currentProjectIdSelector } from '../../../reducers/projects';
import { currentUserIdSelector } from '../../../reducers/auth';
import { getUserLabel } from './helpers';

const projectsUsersSelector = (state) => state.projectsUsers.get('projectsUsers');
const usersMapSelector = (state) => {
  const currentProjectId = currentProjectIdSelector(state);
  const projectUsers = projectsUsersSelector(state).getIn([currentProjectId], []);
  const usersMap = state.users.get('users');
  const projectUsersMap = usersMap.filter((u, k) => projectUsers.has(k));

  if (projectUsersMap.size === 0) return null;
  return projectUsersMap;
};

const EditorComponentSelector = createSelector(
  [usersMapSelector, currentUserIdSelector],
  (usersMap, currentUserId) => ({ usersMap, currentUserId })
);

@connect(EditorComponentSelector)
export default class Editor extends PureComponent {
  static propTypes = {
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    currentUserId: PropTypes.string,
    input: PropTypes.object,
    usersMap: PropTypes.object,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
  };

  populateOptions = () => {
    const { usersMap } = this.props;
    const output = [];
    if (usersMap) {
      output.push(<option key={'Unassigned'} value={''}>Unassigned</option>);
      usersMap.forEach((userFieldName, userIndex) => {
        const currentUser = usersMap.get(userIndex);
        if (!currentUser) return; // should never happen and yet it does appear to!
        const id = currentUser.getIn(['id']);
        const displayName = getUserLabel(currentUser);
        output.push(<option key={id} value={id}>{displayName}</option>);
      });
    }
    return output;
  }

  componentDidMount = () => {
    const { dispatch, input, uid, currentUserId } = this.props;
    if (!input.value) dispatch(change(uid, `${input.name}`, currentUserId));
  };

  render = () => {
    const {
      containerClassName,
      containerStyle,
      input,
      wrapperClassName,
      wrapperStyle,
    } = this.props;

    const displayEditor = (
      <div>
        <div className={wrapperClassName} style={wrapperStyle}>
          <div className={containerClassName} style={containerStyle}>
            <select
              className={'form-control c-select'}
              style={{ display: 'inline-block' }}
              {...input}
            >
              {this.populateOptions()}
            </select>
          </div>
        </div>
      </div>
    );
    return displayEditor;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/UserSelect/Editor.js